
/// <reference types="googlemaps" />

import _memoize from "lodash/memoize"
import Promise from "plugins/bluebird/index"

import WaitObjectByPathPromise from "app/wait_object_by_path_promise"

// @see https://gist.github.com/GFoley83/5953448

/*!
 * JavaScript - loadGoogleMaps( version, apiKey, language, sensor )
 *
 * - Load Google Maps API using jQuery Deferred.
 * Useful if you want to only load the Google Maps API on-demand.
 * - Requires jQuery 1.5
 *
 * UPDATES by Gavin Foley
 * - Tidied JS & made it JSLint compliant
 * - Updated script request to Google Maps API to be protocol relative
 * - Added "sensor" parameter which defaults to false if not present
 *
 * Copyright (c) 2011 Glenn Baker
 * Dual licensed under the MIT and GPL licenses.
 */
interface google {
  // eslint-disable-next-line no-undef
  maps: typeof google.maps
}

declare global {
  interface Window {
    // @ts-ignore
    google: {
      // eslint-disable-next-line no-undef
      maps: typeof google.maps | null,
    } | null,
  }
}

// eslint-disable-next-line no-undef
const asyncLoad = ((window): (() => Promise<typeof google.maps>) => {
// eslint-disable-next-line no-undef
  return _memoize((): Promise<typeof google.maps> => {
    return new Promise((resolve) => {
      // If google.maps exists, then Google Maps API was probably loaded with the <script> tag
      if (window.google != null && window.google.maps != null) {
        resolve(window.google.maps)
        // If the google.load method exists, lets load the Google Maps API in Async.
      }
      else {
        // Since API key is required
        // We wait for script tag to be processed by user agent
        // which should exists in HTML

        void WaitObjectByPathPromise("google.maps", {
          should_log_timeout: true,
        })
        .then((google_maps) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          resolve(google_maps)
        })
      }
    })
  })
})(window)

export default asyncLoad
